'use strict';

angular.module('licensure.services')
    .factory('IPComment', ['$http', '$q', function ($http, $q) {
        return {
            getAdministrativeCommentsByQuestionId: function (fbQuestionID, inspectionID) {
                var d = $q.defer();
                $http.get(apiLocation + '/api/Core/IPComment/AdministrativeComments', {
                    params: {
                        fbQuestionID: fbQuestionID,
                        inspectionID: inspectionID
                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            saveAdministrativeComment: function (comment, questionID, inspectionID) {
                var d = $q.defer();

                $http.post(apiLocation + '/api/Core/IPComment/AdministrativeComment/', {
                    Comment: comment,
                    FBQuestionId: questionID,
                    InspectionId: inspectionID
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            resolveAdministrativeComment: function (id, comment) {
                var d = $q.defer();

                $http
                    .put(apiLocation + '/api/Core/IPComment/ResolveAdministrativeComment/' + id, { id: comment.id })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            toggleShowOnPdf: function (id, comment) {
                var d = $q.defer();

                $http
                    .put(apiLocation + '/api/Core/IPComment/ToggleShowOnPdf/' + id, { id: comment.id, showOnPdf: comment.showOnPdf })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            listIPCommentAsync: function (inspectionId) {
                var d = $q.defer();
                $http.get(apiLocation + '/api/Core/IPComment/ListIPCommentById/' + inspectionId, {
                    params: {

                    }
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                        d.resolve(null);
                    });

                return d.promise;
            },
        }
    }])
    ;